import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import clsx from 'clsx'
import { Toaster } from 'react-hot-toast'
import { useLocation } from 'react-router'

import { QueryClient, QueryClientProvider } from '@fv/client-core'

import SiteProvider from '@/providers/SiteProvider'

import { AdminRoutes } from './AdminRoutes'
import { Nav } from './layout/Nav'

const queryClient = new QueryClient()

export const AuthenticatedApp = () => {
  const location = useLocation()
  const isPricingProposal = location.pathname.startsWith('/pricing-proposals')

  return (
    <QueryClientProvider client={queryClient}>
      <SiteProvider>
        <div
          className={clsx(
            'grid h-screen',
            !isPricingProposal && 'grid-rows-[auto_1fr]',
          )}
        >
          {!isPricingProposal && <Nav />}
          <main role="main" className="flex flex-col overflow-auto">
            <AdminRoutes />
          </main>
        </div>
      </SiteProvider>

      <ReactQueryDevtools
        client={queryClient}
        initialIsOpen={false}
        buttonPosition="bottom-right"
      />
      <Toaster position="bottom-center" />
    </QueryClientProvider>
  )
}
